import { HTTP } from 'providers'

export class OrderTypeOriginService extends HTTP {
  private endpoint = '/order-types-origin'

  public fetchAll() {
    return this.get({ endpoint: this.endpoint })
  }
}
